import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2;

import { css } from "../../../lib/theming/Emotion";
export var menuFooterSizeMixin = function menuFooterSizeMixin(menuFooterLegacyPaddingRight, menuFooterPaddingX, menuFooterFontSize, menuFooterLineHeight, menuFooterPaddingTop, menuFooterPaddingBottom) {
  var legacyPaddingRight = parseFloat(menuFooterLegacyPaddingRight);
  var paddingRight = legacyPaddingRight !== 0 ? parseFloat(menuFooterPaddingX) + legacyPaddingRight + "px" : menuFooterPaddingX;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    font-size: ", ";\n    line-height: ", ";\n    padding: ", " ", " ", " ", ";\n  "])), menuFooterFontSize, menuFooterLineHeight, menuFooterPaddingTop, paddingRight, menuFooterPaddingBottom, menuFooterPaddingX);
};
export var withIconSizeMixin = function withIconSizeMixin(menuItemPaddingForIcon) {
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    padding-left: ", ";\n  "])), menuItemPaddingForIcon);
};